import React from "react";
import Image from "components/image";
import clsx from "clsx/lite";
import Link from "components/link";
import RichText from "./content";

const VideoType = ({ item }) => (
	<Link to={item.link} className="contents">
		<video
			className={item.mobileAsset?.url ? "hidden sm:block w-full" : ""}
			preload="none"
			loading="lazy"
			controls={false}
			playsInline={true}
			autoPlay={true}
			muted={true}
			loop={true}>
			<source src={item.asset?.url + "#t=0.001"} type="video/mp4" />
			Your browser does not support HTML5 video.
		</video>
		{item.mobileAsset?.url &&
			<video
				className="sm:hidden min-h-128"
				preload="none"
				loading="lazy"
				controls={false}
				playsInline={true}
				autoPlay={true}
				muted={true}
				loop={true}>
				<source src={item?.mobileAsset?.url + "#t=0.001"} type="video/mp4" />
				Your browser does not support HTML5 video.
			</video>}
	</Link>
);

const ImageType = ({ item, isFirst }) => (
	<Link to={item.link} className="media-image contents">
		{item.mobileImage &&
			<Image className="sm:!hidden" image={item.mobileImage} loading="eager"
				layout="fullWidth" placeholder="blurred"
				fetchpriority={isFirst ? "high" : "low"} width={768} height={675} />}
		<Image
			className={clsx(item.mobileImage && "!hidden sm:!block", item.content && item.mobileImage && " sm:min-h-96 md:min-h-144")}
			image={item.image} loading="eager" fetchpriority={isFirst ? "high" : "low"} />
	</Link>
);

const Content = ({ item, embedHeader }) => {
	const { textPosition = "bottom", content, limitContentWidth, showOverlayOnText = false } = item;

	return (
		<div className={clsx("media-carousel-content swiper-content-overlay",
			item.hideGradient && "!bg-none",
			embedHeader && "!bg-gradient-to-b")}>
			<div className={
				clsx("md:px-20 md:py-8 px-7 h-full py-6 flex flex-col items-center text-center xxl:max-w-screen-xxl mx-auto xxl:px-6",
					textPosition === "bottom" && "justify-end",
					textPosition === "top" && "justify-start",
					textPosition === "center" && "text-center justify-center",
					textPosition === "spaceBetween" && " justify-between",
					textPosition === "left" &&
					"sm:!items-start *:items-center sm:*:items-start sm:justify-center sm:text-left !w-full gap-8 md:gap-10",
					embedHeader && "mt-80 sm:mt-32 lg:mt-0",
					showOverlayOnText && "lg:!px-16 lg:!pt-44 !justify-center "
				)}>
				{content &&
					<RichText data={content} limitContentWidth={limitContentWidth}
						className={clsx(showOverlayOnText && "bg-black bg-opacity-80 p-6 md:p-12")} />}
			</div>
		</div>
	);
};

const MediaCarouselItem = ({ item, limitHeight, isFirst, embedHeader }) => {
	const aspectRatio = limitHeight ?
		"*:aspect-video *:max-h-144 *:min-h-80 md:*:min-h-144" :
		"*:aspect-[20/9] *:min-h-[625px] sm:*:min-h-full xl:*:min-h-144";

	return (
		<div className="w-full relative">
			<div className={clsx(aspectRatio, "*:w-full *:object-cover *:object-center")}>
				{item.mediaType === "video" ?
					<VideoType item={item} /> :
					<ImageType item={item} isFirst={isFirst} />
				}
			</div>
			{(item.content && item.mediaType !== "video") && <Content item={item} embedHeader={embedHeader} />}
		</div >
	);
};

export default MediaCarouselItem;